import { CommissionDto, SearchCommissionsDto } from './dtos/commission.dto';
import { axiosCore } from './http-core-service';

/**
 * Méthode qui récupère les commissions pour un mandat et utilisateur
 * @return des commissions
 */
export const searchCommissionsFromService = async (data: SearchCommissionsDto): Promise<Array<CommissionDto>> => {
    let criterions = 'mine=true';
    //si recherche par nom
    if (data.paramTitle) {
        criterions += `&title=${data.paramTitle}`;
    }
    //si recherche par collectivité
    if (data.paramDate) {
        criterions += `&date=${data.paramDate}`;
    }
    //si recherche par titre
    if (data.paramMember) {
        criterions += `&member=${data.paramMember}`;
    }
    // Création d'un json pour la requête
    const response = await axiosCore.get(`/api/commissions/search?${criterions}`);
    return response.data;
};
